import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';
import { ButtonSeverity } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

export enum MessageBoxResults {
  Confirmed = "confirmed",
  Canceled = "canceled"
}

@Component({
    selector: 'app-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageBoxComponent implements OnInit {


  @Input() title: string = "";
  @Input() message: string = "";

  @Input() showCopyButton: boolean = false;

  @Input() confirmButtonText: string = "OK";
  @Input() cancelButtonText: string = "Cancel";

  @Input() showConfirmButton: boolean = true;
  @Input() showCancelButton: boolean = true;

  @Input() confirmButtonSeverity: ButtonSeverity = "success"


  copied = signal(false);

  constructor(
    public modalRef: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) { 
    if (config.data.title) this.title = config.data.title
    if (config.data.message) this.message = config.data.message
    if (config.data.showCopyButton) this.showCopyButton = config.data.showCopyButton
    if (config.data.confirmButtonText) this.confirmButtonText = config.data.confirmButtonText
    if (config.data.cancelButtonText) this.cancelButtonText = config.data.cancelButtonText
    if (config.data.showCancelButton || config.data.showCancelButton === false) this.showCancelButton = config.data.showCancelButton
    if (config.data.showConfirmButton || config.data.showConfirmButton === false) this.showConfirmButton = config.data.showConfirmButton
    if (config.data.confirmButtonSeverity) this.confirmButtonSeverity = config.data.confirmButtonSeverity
  }

  ngOnInit(): void {
  }

  onCopy() {
    this.copied.set(true);
  }

}
